import { FC, useState } from 'react';
import { CONFIG } from '../../../config';
import { IImport } from '../../../model/IImport';
import { icons } from '../../icons/IconSet';
import { getTimeDiffString } from '../../utils/getTimeDiff';
import parseISOToDate from '../../utils/ParseISOtoDate';
import Modal from '../common/Modal';
import TableTd from '../common/table/TableTd';
import TableTr from '../common/table/TableTr';
import Truncate from '../Truncate';

const ImportsTaskRow: FC<{ imprt: IImport }> = ({ imprt }) => {  
  const [isModal, setIsModal] = useState<boolean>(false);

  return (
    <TableTr className={`
      ${{
        0: '',
        1: ' bg-orange-200 animate-pulse',
        2: ' bg-green-50 text-green-950',
        3: 'bg-red-50 text-red-950',
        4: ' bg-orange-50 text-orange-900',
      }?.[imprt.status] || ''}
    `}>
      <TableTd align="center">
        {CONFIG.importTypes?.[imprt.status]}
      </TableTd>

      <TableTd align="center">
        {imprt.goalServer}
      </TableTd>

      <TableTd align="center">
        {imprt.productId}
      </TableTd>

      <TableTd align="center">
        {imprt.company}
      </TableTd>

      <TableTd align="center">
        <div className=" whitespace-nowrap">
          {imprt.createdAt && getTimeDiffString({ startDate: parseISOToDate(imprt.createdAt) })}
        </div>
      </TableTd>

      <TableTd align="center">
        {imprt.productUpdatedAt && getTimeDiffString({ startDate: parseISOToDate(imprt.productUpdatedAt) })}
      </TableTd>

    </TableTr>
  )  
}

export default ImportsTaskRow;
